// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-articles-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 2rem;
}

.modal-articles {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 1300px;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.modal-articles-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-bottom: 1px solid #E5E7EB;
  background-color: #FAFAFA;
}

.modal-articles-header h2 {
  color: #2C3948;
  font-size: 2.4rem;
  margin: 0;
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  font-size: 2.4rem;
  cursor: pointer;
  color: #6B7280;
  padding: 0.5rem;
  border-radius: 4px;
  transition: all 0.3s ease;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  background-color: #F3F4F6;
  color: #374151;
}

.modal-articles-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #E5E7EB;
  border-top: 4px solid #DA7027;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.articles-list {
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.article-row {
  display: grid;
  grid-template-columns: 80px 1fr 120px 100px 100px;
  gap: 2rem;
  padding: 2rem;
  border-bottom: 1px solid #E5E7EB;
  align-items: center;
  transition: background-color 0.3s ease;
}

.article-row:hover {
  background-color: #F9FAFB;
}

.article-row:nth-child(even) {
  background-color: #FAFAFA;
}

.article-row:nth-child(even):hover {
  background-color: #F3F4F6;
}

.article-code {
  font-weight: 600;
  color: #2C3948;
  font-size: 1.4rem;
  text-align: center;
}

.article-info {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.article-nom {
  color: #2C3948;
  font-size: 1.4rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
}

.article-prix {
  color: #6B7280;
  font-size: 1.2rem;
}

.prix-value {
  font-weight: 600;
  color: #2C3948;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 0;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
}

.quantity-btn {
  background-color: #F9FAFB;
  border: none;
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.8rem;
  font-weight: 600;
  color: #6B7280;
  transition: all 0.3s ease;
}

.quantity-btn:hover:not(:disabled) {
  background-color: #F3F4F6;
  color: #374151;
}

.quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity-btn.decrease {
  border-right: 1px solid #E5E7EB;
}

.quantity-btn.increase {
  border-left: 1px solid #E5E7EB;
}

.quantity-input {
  border: none;
  width: 5rem;
  height: 3.2rem;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 500;
  color: #2C3948;
  background-color: white;
}

.quantity-input:focus {
  outline: none;
  background-color: #F9FAFB;
}

/* Masquer les flèches des inputs number */
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.quantity-input[type=number] {
  -moz-appearance: textfield;
}

.article-total {
  text-align: right;
  min-height: 2rem; /* CORRECTION: Garder une hauteur minimale même si vide */
}

.total-label {
  color: #6B7280;
  font-size: 1.1rem;
  margin-bottom: 0.2rem;
}

.total-value {
  color: #2C3948;
  font-size: 1.4rem;
  font-weight: 600;
  min-height: 1.4rem; /* CORRECTION: Hauteur minimale pour éviter le décalage */
}

.modal-articles-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-top: 1px solid #E5E7EB;
  background-color: #FAFAFA;
}

.footer-summary {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.selected-count {
  color: #6B7280;
  font-size: 1.3rem;
}

.footer-total {
  color: #2C3948;
  font-size: 1.6rem;
  font-weight: 600;
}

.total-amount {
  color: #DA7027;
}

.footer-actions {
  display: flex;
  gap: 1rem;
}

/* NOUVEAUTÉ: Style pour les articles ajoutés à la commande (grisés) */
.article-row.article-added {
  background-color: #f8f9fa !important;
  color: #6c757d;
  border-left: 4px solid #DA7027;
}

.article-row.article-added:hover {
  background-color: #e9ecef !important;
}

.article-row.article-added .article-nom {
  color: #6c757d;
}

.article-row.article-added .article-prix {
  color: #6c757d;
}

.article-row.article-added .prix-value {
  color: #6c757d;
}

/* Garder les contrôles de quantité actifs même sur les articles grisés */
.article-row.article-added .quantity-controls {
  opacity: 1;
}

.article-row.article-added .quantity-btn,
.article-row.article-added .quantity-input {
  opacity: 1;
}

/* Style pour le total quand l'article est ajouté */
.article-row.article-added .total-value {
  font-weight: 600;
}

.prix-placeholder {
  font-style: italic;
  color: #9CA3AF;
  font-size: 1.1rem;
}

/* État de sauvegarde */
.modal-articles.saving {
  pointer-events: none;
}

.modal-articles.saving .modal-articles-content {
  opacity: 0.7;
}

/* Styles pour les boutons pendant la sauvegarde */
.quantity-btn:disabled,
.quantity-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.close-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* NOUVEAU: Styles pour la barre de recherche */
.modal-articles-search {
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #E5E7EB;
  background-color: #FAFAFA;
}

.search-info {
  margin-top: 1rem;
  color: #6B7280;
  font-size: 1.3rem;
  text-align: center;
}

.search-info span {
  font-weight: 500;
}

/* Assurer que la SearchBar prend toute la largeur */
.modal-articles-search .search-bar {
  width: 100%;
}

/* Animation pour les résultats de recherche */
.articles-list {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Style pour l'état "Aucun résultat" */
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.error-state p {
  color: #6B7280;
  font-size: 1.6rem;
  margin-bottom: 2rem;
}

/* Améliorer l'accessibilité avec focus visible sur la recherche */
.modal-articles-search input:focus {
  outline: 2px solid #DA7027;
  outline-offset: 2px;
}

/* Responsive */
@media (max-width: 1024px) {
  .article-row {
    grid-template-columns: 70px 1fr 100px 90px 80px;
    gap: 1rem;
    padding: 1.5rem;
  }

  .article-nom {
    font-size: 1.3rem;
  }

  .quantity-controls {
    transform: scale(0.9);
  }
}

@media (max-width: 768px) {
  .modal-articles-overlay {
    padding: 1rem;
  }

  .modal-articles {
    max-height: 95vh;
  }

  .article-row {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1.5rem;
    text-align: left;
  }

  .article-code {
    text-align: left;
    font-size: 1.2rem;
  }

  .quantity-controls {
    justify-self: start;
    transform: none;
  }

  .article-total {
    text-align: left;
  }

  .details-btn {
    justify-self: start;
    width: fit-content;
  }

  .modal-articles-footer {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }

  .footer-actions {
    width: 100%;
  }

  .footer-actions button {
    flex: 1 1;
  }
}

@media (max-width: 480px) {
  .modal-articles-header {
    padding: 1.5rem;
  }

  .modal-articles-header h2 {
    font-size: 2rem;
  }

  .article-row {
    padding: 1rem;
  }

  .modal-articles-footer {
    padding: 1.5rem;
  }

  .prix-table th:first-child,
  .prix-table td:first-child {
    width: 120px;
    font-size: 1.1rem;
  }

  .article-details-expanded {
    padding: 1rem;
  }
}

/* Conteneur d'article avec détails */
.article-container {
  border-bottom: 1px solid #E5E7EB;
}

.article-container:last-child {
  border-bottom: none;
}

/* Section des détails expandable */
.article-details-expanded {
  padding: 2rem;
  background-color: #F8F9FA;
  border-top: 1px solid #E5E7EB;
  animation: slideDown 0.3s ease-out;
}

.details-header h5 {
  color: #DA7027;
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.details-description {
  margin-bottom: 2rem;
}

.details-description p {
  color: #374151;
  font-size: 1.4rem;
  line-height: 1.6;
  margin: 0;
}

.prix-degressifs h6 {
  color: #2C3948;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.prix-table {
  overflow-x: auto;
}

.prix-table table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.prix-table th {
  background-color: #F3F4F6;
  color: #374151;
  font-weight: 600;
  padding: 1.2rem;
  text-align: center;
  border-bottom: 1px solid #E5E7EB;
  font-size: 1.3rem;
}

.prix-table th:first-child {
  text-align: left;
  width: 200px;
}

.prix-table td {
  padding: 1.2rem;
  border-bottom: 1px solid #E5E7EB;
  font-size: 1.3rem;
  text-align: center;
}

.prix-table td:first-child {
  text-align: left;
  font-weight: 500;
  color: #2C3948;
}

.prix-table tbody tr:hover {
  background-color: #F9FAFB;
}

.prix-table tbody tr:last-child td {
  border-bottom: none;
}

.loading-details {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: #6B7280;
  font-style: italic;
}

/* Animation pour l'expansion */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 500px;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .prix-table {
    font-size: 1.2rem;
  }

  .prix-table th,
  .prix-table td {
    padding: 0.8rem;
  }

  .prix-table th:first-child,
  .prix-table td:first-child {
    width: 150px;
  }

  .article-details-expanded {
    padding: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/composants/ModalArticles/ModalArticles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB,EAAE,yDAAyD;AAC/E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,sEAAsE;AACtE;EACE,oCAAoC;EACpC,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA,kDAAkD;AAClD;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,+CAA+C;IAC/C,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".modal-articles-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 2rem;\n}\n\n.modal-articles {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 1300px;\n  max-height: 95vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.modal-articles-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-bottom: 1px solid #E5E7EB;\n  background-color: #FAFAFA;\n}\n\n.modal-articles-header h2 {\n  color: #2C3948;\n  font-size: 2.4rem;\n  margin: 0;\n  font-weight: 600;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 2.4rem;\n  cursor: pointer;\n  color: #6B7280;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n  width: 4rem;\n  height: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-button:hover {\n  background-color: #F3F4F6;\n  color: #374151;\n}\n\n.modal-articles-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #E5E7EB;\n  border-top: 4px solid #DA7027;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.articles-list {\n  display: flex;\n  flex-direction: column;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.article-row {\n  display: grid;\n  grid-template-columns: 80px 1fr 120px 100px 100px;\n  gap: 2rem;\n  padding: 2rem;\n  border-bottom: 1px solid #E5E7EB;\n  align-items: center;\n  transition: background-color 0.3s ease;\n}\n\n.article-row:hover {\n  background-color: #F9FAFB;\n}\n\n.article-row:nth-child(even) {\n  background-color: #FAFAFA;\n}\n\n.article-row:nth-child(even):hover {\n  background-color: #F3F4F6;\n}\n\n.article-code {\n  font-weight: 600;\n  color: #2C3948;\n  font-size: 1.4rem;\n  text-align: center;\n}\n\n.article-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.article-nom {\n  color: #2C3948;\n  font-size: 1.4rem;\n  font-weight: 500;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.article-prix {\n  color: #6B7280;\n  font-size: 1.2rem;\n}\n\n.prix-value {\n  font-weight: 600;\n  color: #2C3948;\n}\n\n.quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: white;\n}\n\n.quantity-btn {\n  background-color: #F9FAFB;\n  border: none;\n  width: 3.2rem;\n  height: 3.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #6B7280;\n  transition: all 0.3s ease;\n}\n\n.quantity-btn:hover:not(:disabled) {\n  background-color: #F3F4F6;\n  color: #374151;\n}\n\n.quantity-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.quantity-btn.decrease {\n  border-right: 1px solid #E5E7EB;\n}\n\n.quantity-btn.increase {\n  border-left: 1px solid #E5E7EB;\n}\n\n.quantity-input {\n  border: none;\n  width: 5rem;\n  height: 3.2rem;\n  text-align: center;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #2C3948;\n  background-color: white;\n}\n\n.quantity-input:focus {\n  outline: none;\n  background-color: #F9FAFB;\n}\n\n/* Masquer les flèches des inputs number */\n.quantity-input::-webkit-outer-spin-button,\n.quantity-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.quantity-input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.article-total {\n  text-align: right;\n  min-height: 2rem; /* CORRECTION: Garder une hauteur minimale même si vide */\n}\n\n.total-label {\n  color: #6B7280;\n  font-size: 1.1rem;\n  margin-bottom: 0.2rem;\n}\n\n.total-value {\n  color: #2C3948;\n  font-size: 1.4rem;\n  font-weight: 600;\n  min-height: 1.4rem; /* CORRECTION: Hauteur minimale pour éviter le décalage */\n}\n\n.modal-articles-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-top: 1px solid #E5E7EB;\n  background-color: #FAFAFA;\n}\n\n.footer-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.selected-count {\n  color: #6B7280;\n  font-size: 1.3rem;\n}\n\n.footer-total {\n  color: #2C3948;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n.total-amount {\n  color: #DA7027;\n}\n\n.footer-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n/* NOUVEAUTÉ: Style pour les articles ajoutés à la commande (grisés) */\n.article-row.article-added {\n  background-color: #f8f9fa !important;\n  color: #6c757d;\n  border-left: 4px solid #DA7027;\n}\n\n.article-row.article-added:hover {\n  background-color: #e9ecef !important;\n}\n\n.article-row.article-added .article-nom {\n  color: #6c757d;\n}\n\n.article-row.article-added .article-prix {\n  color: #6c757d;\n}\n\n.article-row.article-added .prix-value {\n  color: #6c757d;\n}\n\n/* Garder les contrôles de quantité actifs même sur les articles grisés */\n.article-row.article-added .quantity-controls {\n  opacity: 1;\n}\n\n.article-row.article-added .quantity-btn,\n.article-row.article-added .quantity-input {\n  opacity: 1;\n}\n\n/* Style pour le total quand l'article est ajouté */\n.article-row.article-added .total-value {\n  font-weight: 600;\n}\n\n.prix-placeholder {\n  font-style: italic;\n  color: #9CA3AF;\n  font-size: 1.1rem;\n}\n\n/* État de sauvegarde */\n.modal-articles.saving {\n  pointer-events: none;\n}\n\n.modal-articles.saving .modal-articles-content {\n  opacity: 0.7;\n}\n\n/* Styles pour les boutons pendant la sauvegarde */\n.quantity-btn:disabled,\n.quantity-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.close-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* NOUVEAU: Styles pour la barre de recherche */\n.modal-articles-search {\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #E5E7EB;\n  background-color: #FAFAFA;\n}\n\n.search-info {\n  margin-top: 1rem;\n  color: #6B7280;\n  font-size: 1.3rem;\n  text-align: center;\n}\n\n.search-info span {\n  font-weight: 500;\n}\n\n/* Assurer que la SearchBar prend toute la largeur */\n.modal-articles-search .search-bar {\n  width: 100%;\n}\n\n/* Animation pour les résultats de recherche */\n.articles-list {\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Style pour l'état \"Aucun résultat\" */\n.error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n}\n\n.error-state p {\n  color: #6B7280;\n  font-size: 1.6rem;\n  margin-bottom: 2rem;\n}\n\n/* Améliorer l'accessibilité avec focus visible sur la recherche */\n.modal-articles-search input:focus {\n  outline: 2px solid #DA7027;\n  outline-offset: 2px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .article-row {\n    grid-template-columns: 70px 1fr 100px 90px 80px;\n    gap: 1rem;\n    padding: 1.5rem;\n  }\n\n  .article-nom {\n    font-size: 1.3rem;\n  }\n\n  .quantity-controls {\n    transform: scale(0.9);\n  }\n}\n\n@media (max-width: 768px) {\n  .modal-articles-overlay {\n    padding: 1rem;\n  }\n\n  .modal-articles {\n    max-height: 95vh;\n  }\n\n  .article-row {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    padding: 1.5rem;\n    text-align: left;\n  }\n\n  .article-code {\n    text-align: left;\n    font-size: 1.2rem;\n  }\n\n  .quantity-controls {\n    justify-self: start;\n    transform: none;\n  }\n\n  .article-total {\n    text-align: left;\n  }\n\n  .details-btn {\n    justify-self: start;\n    width: fit-content;\n  }\n\n  .modal-articles-footer {\n    flex-direction: column;\n    gap: 1.5rem;\n    text-align: center;\n  }\n\n  .footer-actions {\n    width: 100%;\n  }\n\n  .footer-actions button {\n    flex: 1;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-articles-header {\n    padding: 1.5rem;\n  }\n\n  .modal-articles-header h2 {\n    font-size: 2rem;\n  }\n\n  .article-row {\n    padding: 1rem;\n  }\n\n  .modal-articles-footer {\n    padding: 1.5rem;\n  }\n\n  .prix-table th:first-child,\n  .prix-table td:first-child {\n    width: 120px;\n    font-size: 1.1rem;\n  }\n\n  .article-details-expanded {\n    padding: 1rem;\n  }\n}\n\n/* Conteneur d'article avec détails */\n.article-container {\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.article-container:last-child {\n  border-bottom: none;\n}\n\n/* Section des détails expandable */\n.article-details-expanded {\n  padding: 2rem;\n  background-color: #F8F9FA;\n  border-top: 1px solid #E5E7EB;\n  animation: slideDown 0.3s ease-out;\n}\n\n.details-header h5 {\n  color: #DA7027;\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.details-description {\n  margin-bottom: 2rem;\n}\n\n.details-description p {\n  color: #374151;\n  font-size: 1.4rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.prix-degressifs h6 {\n  color: #2C3948;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.prix-table {\n  overflow-x: auto;\n}\n\n.prix-table table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.prix-table th {\n  background-color: #F3F4F6;\n  color: #374151;\n  font-weight: 600;\n  padding: 1.2rem;\n  text-align: center;\n  border-bottom: 1px solid #E5E7EB;\n  font-size: 1.3rem;\n}\n\n.prix-table th:first-child {\n  text-align: left;\n  width: 200px;\n}\n\n.prix-table td {\n  padding: 1.2rem;\n  border-bottom: 1px solid #E5E7EB;\n  font-size: 1.3rem;\n  text-align: center;\n}\n\n.prix-table td:first-child {\n  text-align: left;\n  font-weight: 500;\n  color: #2C3948;\n}\n\n.prix-table tbody tr:hover {\n  background-color: #F9FAFB;\n}\n\n.prix-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.loading-details {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  color: #6B7280;\n  font-style: italic;\n}\n\n/* Animation pour l'expansion */\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n    max-height: 500px;\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .prix-table {\n    font-size: 1.2rem;\n  }\n\n  .prix-table th,\n  .prix-table td {\n    padding: 0.8rem;\n  }\n\n  .prix-table th:first-child,\n  .prix-table td:first-child {\n    width: 150px;\n  }\n\n  .article-details-expanded {\n    padding: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
